import { createFileRoute } from '@tanstack/react-router';
import { TrialsListPage } from '@/modules/trials/pages/TrialsListPage';

export const Route = createFileRoute('/dashboard/trials/')({
  component: TrialsListPage,
});
